<template>
  <v-navigation-drawer
    v-model="$store.state.drawer"
    absolute
    temporary>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <img
            v-if="photoURL"
            :src="photoURL">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ userName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />
      <v-list-item
        v-if="$store.state.login_user"
        :to="{ name: 'home' }">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ユーザ情報設定</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="isRegisteredUser"
        :to="{ name: 'calendar' }">
        <v-list-item-icon>
          <v-icon>mdi-calendar</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>カレンダー</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="(item, index) in extItems"
        :key="index"
        :href="item.link">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      extItems: [
        {
          title: 'チュートリアル',
          icon: 'mdi-book-open',
          link: 'https://www.sai-labo.co.jp/tutorial',
        },
        {
          title: 'メッセージ投稿',
          icon: 'mdi-message-text-outline',
          link: 'https://www.sai-labo.co.jp/creview',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['userName', 'photoURL', 'isRegisteredUser']),
  },
}
</script>
